import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface LocalSettingsProps {
  isVisible: boolean
}

export const LocalSettingsWrapper = styled.div<LocalSettingsProps>`
  width: ${({ isVisible }) => (isVisible ? '100%' : 0)};
  transform: ${({ isVisible }) => (isVisible ? 'translateX(0)' : 'translateX(16px)')};
  overflow: hidden;
  transition:
    width 0.4s ease-in-out,
    transform 0.4s ease-in-out;
  will-change: width, transform;
`

export const LocalSettingsContent = styled.div<LocalSettingsProps>`
  display: flex;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  gap: ${Spacing.S8};
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
  transition: opacity 0.5s ease-in-out;
`

export const LinkToGlobalSettingsWrapper = styled.div`
  min-width: fit-content;
`

export const LocalSettingsDisplayTriggerWrapper = styled.div`
  min-width: ${Spacing.S32};
  z-index: 1;
`
